import React, { useEffect } from 'react';

import CoachingView from 'coaching/components/CoachingView';
import ErrorReporter from 'app/components/ErrorReporter';
import EventTracking from 'lib/EventTracking';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import CoachingBillingDetailCard from 'coaching/components/CoachingBillingView/CoachingBillingDetailCard';

import GetCoachingUserStripeSourceContainer from 'coaching/containers/GetCoachingUserStripeSourceContainer';

export const coachingBillingViewPrefix = 'coaching.coaching_billing_view';

export default function CoachingBillingView() {
  useEffect(() => {
    EventTracking.trackKey(`${coachingBillingViewPrefix}.view`);
  }, []);
  return (
    <CoachingView headerType="none">
      <GetCoachingUserStripeSourceContainer>
        {({ creditCard, loading, error }) => {
          if (loading) {
            return <CenteredLoadingIndicator data-test="centered-loading" />;
          }
          if (typeof creditCard === 'undefined' && error) {
            return <ErrorReporter error="CoachingBillingView - Error getting card information" />;
          }
          if (typeof creditCard === 'undefined') {
            return null;
          }
          const info = creditCard
            ? { brand: creditCard?.cardBrand, lastFour: creditCard?.cardLastFour }
            : {};
          return (
            <div className="CoachingBillingView-container">
              <CoachingBillingDetailCard cardDetail={{ info }} />
            </div>
          );
        }}
      </GetCoachingUserStripeSourceContainer>
    </CoachingView>
  );
}
